import React from "react"
import i18n from "@/utils/i18n"
import ErrorPage from "../ErrorPage"

const NotFoundPage: React.FC = () => {
  return (
    <ErrorPage
      errorCode="404"
      titleKey="errors.notFound.title"
      titleDefault={i18n.t("errors.notFound.title")}
      descriptionKey="errors.notFound.description"
      descriptionDefault={i18n.t("errors.notFound.description")}
      buttonKey="errors.notFound.goToDashboard"
      buttonDefault={i18n.t("errors.notFound.goToDashboard")}
    />
  )
}

export default NotFoundPage
